
const TransformationIntroSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-12 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
            The MSSP Transformation
          </h2>
          
          {/* Two box layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Left Box */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 md:p-10">
              <div className="space-y-6 text-left">
                <p className="text-lg leading-relaxed text-gray-700">
                  Managed security service providers are now carrying the weight of modern cyber complexity.
                </p>
                <p className="text-lg leading-relaxed text-gray-700">
                  What once overwhelmed in-house teams - dynamic threats, false positives, alert fatigue, and overburdened SOCs - has now shifted to MSSPs.
                </p>
                <p className="text-lg leading-relaxed text-gray-700 font-semibold">
                  But the model hasn't evolved fast enough to keep up.
                </p>
                <p className="text-lg leading-relaxed text-[#8932c8] font-bold">
                  That's where Spharaka steps in.
                </p>
              </div>
            </div>

            {/* Right Box */}
            <div className="bg-gradient-to-br from-[#8932c8]/5 to-[#b87ade]/5 rounded-2xl shadow-xl border-2 border-[#8932c8]/20 p-8 md:p-10">
              <div className="space-y-6 text-left">
                <p className="text-lg leading-relaxed text-gray-700">
                  With our <span className="font-bold text-[#8932c8]">Agentic AI engine - Aura XP</span>, we enable MSSPs to break free from reactive operations and become autonomous, outcome-driven security partners.
                </p>
                <p className="text-lg leading-relaxed text-gray-700">
                  Expect faster detection, smarter decisions, and hands-free remediation across tenants and attack surfaces - at scale.
                </p>
                <p className="text-lg leading-relaxed text-gray-700 font-semibold">
                  This is more than an upgrade.
                </p>
                <p className="text-lg leading-relaxed text-gray-700 font-semibold">
                  It's a shift in how MSSPs operate, grow, and lead.
                </p>
                <p className="text-xl font-bold text-[#8932c8] leading-relaxed">
                  Get ready for the transformation. The future of managed security starts with Spharaka.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransformationIntroSection;
